import React, {useEffect, useState} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getSiteEnvVarValue} from './site-config'
import Script from '../components/script'

const hasConsent = (vendorId) => window.Didomi?.getUserConsentStatusForVendor(vendorId)

/**
 * Loads the Vicky SDK script after Didomi grants the configured vendor.
 * The script URL comes from VICKYSDK_SCRIPT_SRC.
 */
export function VickySDK() {
    const {site} = useMultiSite()
    const siteId = site?.id
    const [src, setSrc] = useState(null)

    useEffect(() => {
        const {app} = getConfig()

        if (getSiteEnvVarValue(app, 'IS_VICKYSDK_ENABLED', siteId) !== 'true') {
            return undefined
        }

        const scriptSrc = getSiteEnvVarValue(app, 'VICKYSDK_SCRIPT_SRC', siteId)
        const vendorId = getSiteEnvVarValue(app, 'VICKYSDK_DIDOMI_VENDOR_ID', siteId)
        if (!scriptSrc || !vendorId) return undefined

        const sync = () => setSrc(hasConsent(vendorId) ? scriptSrc : null)
        sync()

        if (window.Didomi?.on) {
            window.Didomi.on('consent.changed', sync)
            return () => window.Didomi?.off?.('consent.changed', sync)
        }

        return undefined
    }, [siteId])

    if (!src) return null

    return <Script src={src} />
}
